// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarTipoJanela,
  getTipoJanelaSelecionada,
  getTiposJanelaAExibir,
} from "../../../../../../state";

export default function SelecaoTipoJanela() {
  return (
    <SelecaoRadioBaseComTraducao
      chaveTraducaoNomeSelecao="preposicaoEm.maiusculas"
      itensSelector={getTiposJanelaAExibir}
      selectorItemSelecionado={getTipoJanelaSelecionada}
      onItemChange={selecionarTipoJanela}
      campoId="id"
      campoChaveTraducao="chaveTraducao"
    />
  );
}
